// /orgs/$orgSlug/projects/$projectId/share-links (PRD §9.9, B6 PR6 / B6f).
//
// Route shell. Project access is enforced server-side by
// `get_project_access`; surface 403 / 404 here so the user sees a
// useful page on access errors rather than the default boundary.

import { createFileRoute, Link } from '@tanstack/react-router';

import { ApiError, apiErrorMessage } from '../api/client';
import { ShareLinksPage } from '../components/ShareLinksPage';

export const Route = createFileRoute(
  '/orgs/$orgSlug/projects/$projectId/share-links'
)({
  component: ShareLinksRoute,
  errorComponent: ShareLinksRouteError,
});

function ShareLinksRoute(): React.JSX.Element {
  const { orgSlug, projectId } = Route.useParams();
  return <ShareLinksPage orgSlug={orgSlug} projectId={projectId} />;
}

function ShareLinksRouteError({
  error,
}: {
  error: unknown;
}): React.JSX.Element {
  const isApi = error instanceof ApiError;
  const status = isApi ? error.status : null;
  const heading =
    status === 403
      ? 'You don’t have access to this project'
      : status === 404
        ? 'Project not found'
        : 'Something went wrong loading share links';
  const body = apiErrorMessage(error, 'Try again, or pick a different project from the organization page.');

  return (
    <div className="mx-auto max-w-2xl py-7">
      <p className="text-text-faint text-11 mb-2 uppercase tracking-wider">
        Error
      </p>
      <h1 className="text-text text-28 mb-3 font-semibold">{heading}</h1>
      <p className="text-text-muted mb-5 text-13">{body}</p>
      <Link
        to="/"
        className="bg-accent text-accent-fg border-border-strong rounded-2 hover:bg-accent-hi inline-block border px-3 py-2 text-13 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
